module.exports = __webpack_public_path__ + "static/media/3browbomber.7db24b1c.png";